import { IClassname } from '@/lib/shared/model/classname';

export const Fridge = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.69353 1.30371H24.3064C24.3064 1.30371 26.8623 1.30371 26.8623 3.85954V26.862C26.8623 26.862 26.8623 29.4179 24.3064 29.4179H7.69353C7.69353 29.4179 5.1377 29.4179 5.1377 26.862V3.85954C5.1377 3.85954 5.1377 1.30371 7.69353 1.30371Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.97144 30.6959V29.418"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.0286 30.6959V29.418"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.1377 11.5273H26.8623"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.97144 3.85938V8.97104"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.97144 14.083V21.7505"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
